import { render, staticRenderFns } from "./25.vue?vue&type=template&id=f7fb4f76&scoped=true&"
import script from "./25.vue?vue&type=script&lang=js&"
export * from "./25.vue?vue&type=script&lang=js&"
import style0 from "./25.vue?vue&type=style&index=0&id=f7fb4f76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7fb4f76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
